import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { UserDetailsFacade } from '@piqet-angular/data';
import { CustomModalService } from '@piqet-angular/shared';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'piqet-angular-select-organization',
  templateUrl: './select-organization.component.html',
  styleUrls: ['./select-organization.component.scss'],
})
export class SelectOrganizationComponent {
  radioSelected: any;
  currentOrganization: any;
  isCheck = true;
  organizationList: any = [];
  selectedOrganization: any = [];
  isShowClearIcon = false;

  @Output() changeOrganization = new EventEmitter<any>();
  searchControl = new FormControl('');

  constructor(
    private modal: CustomModalService,
    public UserDetailsFacade: UserDetailsFacade,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
    this.organizationList = this.modal?.modalService?.config?.initialState?.['organizationList'];
    this.selectedOrganization = this.organizationList;
    this.organizationList?.map((data: any) => {
      if (this.isCheck === data.isCheck) {
        this.radioSelected = data;
        this.currentOrganization = data;
      }
    });
  }

  onClose() {
    this.modal.close();
  }

  save(id: any) {
    const data = {
      organizationMembershipId: id,
      userId: this.cookieService.get('userId'),
    };
    this.changeOrganization.emit(data);
    this.onClose();
  }

  callFilter(event: any) {
    this.isShowClearIcon = true;
    if (!event.target.value.length) {
      return this.clearSearchBox();
    } else {
      this.selectedOrganization = this.organizationList?.filter((item: any) =>
        item.name.toLowerCase().startsWith(event.target.value.toLowerCase())
      );
    }
  }

  clearSearchBox() {
    this.selectedOrganization = this.organizationList;
    this.searchControl.setValue(null);
    this.isShowClearIcon = false;
  }
}
